//*********************************Popup AddField**************************************
import React, { Component, ChangeEvent } from "react";

import {Modal, Form, FormCheck, Button, Container, Row, Col  } from 'react-bootstrap';




interface AddFieldModalProps {
  show: boolean;
  showNested: boolean;
  handleClose: () => void;
  handleSave: (data: any) => void;
}


interface AddFieldModalState {
  nested: boolean;
  name: string;
  label: string;
}

class AddFieldModal extends Component<AddFieldModalProps, AddFieldModalState> {
  constructor(props: AddFieldModalProps) {
    super(props);
    this.state = {
      nested: false,
      name: '',
      label: ''
    };
  }
  
  componentDidUpdate(prevProps: AddFieldModalProps) {
    if (prevProps.show !== this.props.show) {
      this.setState({ 
        nested: false,
        name: '',
        label: '' });
    }
  }
  
  handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    let { nodeName, type, name, value, checked } = event.target;
	
    this.setState((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value,
    }));

  };
	
  handleSubmit = () =>{
    if (!this.state.name || this.state.name.trim().length === 0){
      alert('Name is missing');
      return;
    }
    if (!this.state.label || this.state.label.trim().length === 0){
      alert('Label is missing');
      return;
    }
    this.props.handleSave({name:this.state.name, label:this.state.label, nested:this.state.nested});
  }
  

  render() {
    const { show, handleClose } = this.props;
	const fixedWidthStyle = { width: '240px' }; // Set desired width
    const modalTitle = !this.props.showNested ? 'Entity' : 'Add Attribute';
    

    return (
      <Modal show={show} onHide={handleClose} dialogClassName="field-edit-modal">
		
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            {this.props.showNested &&
            <Row className="mt-2">
              <Col>
                <Form.Group controlId="nested">
                  <Form.Label>Nested ?</Form.Label>
                  <FormCheck
				    type="checkbox"
                    style={fixedWidthStyle}
                    name="nested"
                    checked={this.state.nested}
                    onChange={this.handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            }
            <Row className="mt-2">
              <Col>
                <Form.Group controlId="name">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    style={fixedWidthStyle}
                    name="name"
                    value={this.state.name}
                    onChange={this.handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <Form.Group controlId="label">
                  <Form.Label>Label</Form.Label>
                  <Form.Control
                    type="text"
                    style={fixedWidthStyle}
                    name="label"
                    value={this.state.label}
                    onChange={this.handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Container>
          <div className="d-flex justify-content-end align-items-center" >
              <Button variant="outline-primary" className="mr-2" size="sm" onClick={this.handleSubmit}>
                  Add
              </Button>
          </div>
			
        </Modal.Body>
		
      </Modal>
    );
  }
}



export default AddFieldModal;
